<template>
  <div>
    <div class="dashboard-title">
      {{ $t("dashboard.transactions.allTitle") }}
    </div>
    <div class="d-flex gap-5 py-3 transaction-category">
        <span :class="category == 'cash' && 'color-gold'" @click="switchCat('cash')">{{ $t("dashboard.transactions.cash") }}</span>
        <span :class="category == 'GCoins' && 'color-gold'" @click="switchCat('GCoins')">{{ $t("dashboard.transactions.GCoins") }}</span>
        <span :class="category == 'diamonds' && 'color-gold'" @click="switchCat('diamonds')">{{ $t("dashboard.transactions.diamonds") }}</span>
        <span :class="category == 'commissions' && 'color-gold'" @click="switchCat('commissions')">{{ $t("dashboard.transactions.commissions") }}</span>
    </div>
    <div class="transaction-table">
      <b-table striped hover :items="transactions" :fields="fields"></b-table>
    </div>
  </div>
</template>

<script>
import { BTable } from "bootstrap-vue";

export default {
  components: {
    BTable,
  },
  data() {
    return {
        category: "cash",
      transactions: [
        {
          date: "",
          time: "",
          transaction: "",
          amount: "",
        },
      ],
      fields: [
        {
          key: "date",
          label: this.$t("dashboard.transactions.date"),
          sortable: true,
        },
        {
          key: "time",
          label: this.$t("dashboard.transactions.time"),
        },
        {
          key: "transaction",
          label: this.$t("dashboard.transactions.transaction"),
        },
        {
          key: "amount",
          label: this.$t("dashboard.transactions.amount"),
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(cat) {
      // 调用API获取数据，根据cat调用相应分类的数据
      console.log(cat);
      this.transactions = [];
      for (let index = 0; index < 26; index++) {
        const start = new Date(2019, 0, 1);
        const end = new Date();
        const randomDate = new Date(
          start.getTime() + Math.random() * (end.getTime() - start.getTime())
        );
        let dateFilter = randomDate;
        if (this.date) {
          dateFilter = new Date(this.date);
        }
        const dateString =
          dateFilter.getFullYear() +
          "-" +
          ("0" + (dateFilter.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + dateFilter.getDate()).slice(-2);
        const timeString =
          ("0" + randomDate.getHours()).slice(-2) +
          ":" +
          ("0" + randomDate.getMinutes()).slice(-2);
        const element = {
          date: dateString,
          time: timeString,
          transaction: "Transaction Code",
          amount: this.numberWithCommas(Math.floor(Math.random() * 10000)),
        };
        this.transactions.push(element);
      }
      // 语言切换后表格标题需要重新初始化一下
      this.fields = [
        {
          key: "date",
          label: this.$t("dashboard.transactions.date"),
          sortable: true,
        },
        {
          key: "time",
          label: this.$t("dashboard.transactions.time"),
        },
        {
          key: "transaction",
          label: this.$t("dashboard.transactions.transaction"),
        },
        {
          key: "amount",
          label: this.$t("dashboard.transactions.amount"),
          sortable: true,
        },
      ];
    },
    switchCat(cat) {
        this.category = cat;
        this.getData(cat);
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  watch: {
    "$i18n.locale": function () {
      this.getData();
    },
  },
};
</script>

<style>
.transaction-category {
    font-weight: bold;
}
</style>
